import * as React from 'react'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from '../../store'
import LocationsSelector from './locations_selector'
import { initBoxes } from '../../actions/campaigns/locations_selector_actions'

type LocationsSelectorAppProps = {
  id: number
  approvedLocationIDs: number[]
  campaignLocationsNeedApproval: boolean
  exportLocationApprovalsUrl: string
  step: number
  locations: any
  tags: any
  regions: any
  isReady: boolean
  selectedTags: any
  companyId: number
  canCreateLocation: boolean
  countries: Array<{ label: string; value: string }>
}

function LocationsSelectorApp(props: LocationsSelectorAppProps) {
  const {
    id,
    approvedLocationIDs,
    campaignLocationsNeedApproval,
    exportLocationApprovalsUrl,
    locations,
    tags,
    selectedTags,
    isReady,
    step,
    regions,
    companyId,
    canCreateLocation,
    countries,
  } = props

  useEffect(() => {
    store.dispatch(
      initBoxes({
        id,
        approvedLocationIDs,
        campaignLocationsNeedApproval,
        exportLocationApprovalsUrl,
        step,
        locations,
        tags,
        regions,
        isReady,
        companyId,
        canCreateLocation,
        countries,
      })
    )

  }, [])

  return (
    <Provider store={store}>
      <LocationsSelector />
    </Provider>
  )
}

export default LocationsSelectorApp
